import React, { useState, useEffect } from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import I18n from "../../../../base/i18n.js";

import Button from "../../../../base/buttons/button.js";

const blockStyles = makeStyles(theme => ({
  root: {
    display: "block",
    fontSize: "20px",
    margin: "50px auto 0",
    maxWidth: "410px",
    padding: "8px 20px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      margin: "40px auto 0",
      fontSize: "18px",
      padding: "10px 20px",
    }
  },
}));

const SubmitButton = (props) => {
  const classes = blockStyles();
  const { className } = props;
  
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    setDisabled(props.disabled);
  }, [props.disabled]);
  
  return (
    <Button className = { clsx(classes.root, className) }
            type = { "submit" }
            disabled = { disabled } >
      { I18n.t("action.save") }
    </Button>
  );
};

export default SubmitButton;